import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Input, Textarea, Select } from 'components/fields'
import { connect } from 'react-redux'
import awardFileActivitySectionSelector from '../../../../redux/selectors/codeLists/awardFileActivitySectionSelector'
import { AWARD_FILE_CATEGORY_TYPES } from '../../../../constants/enums'
import styles from './award-file-info.styl'
import { get } from 'lodash'

@connect(state => ({
    awardFileActivitySection: awardFileActivitySectionSelector(state)
}))
class AwardFileInfo extends Component {
    static propTypes = {
        codeLists: PropTypes.object.isRequired,
        awardFileActivitySection: PropTypes.array,
        isJourney: PropTypes.bool,
        data: PropTypes.object,
        isContainParentalConsent: PropTypes.bool.isRequired,
        initialize: PropTypes.func.isRequired
    }

    static defaultProps = {}

    state = {
        showActivitySection: false || (get(this.props.data, 'category.value') === AWARD_FILE_CATEGORY_TYPES.activity.id),
        category: get(this.props.data, 'category.value') || null
    }

    componentDidMount() {
        if(this.props.isJourney){
            this.initForm()
        }
    }


    initForm = () => {
        let initObj = { ...this.props.data }
        initObj['category'] = { value: AWARD_FILE_CATEGORY_TYPES.adventureJourney.id}
        this.props.initialize(initObj)
    }


    getFileCategoryList = (codeLists, isJourney, isContainParentalConsent) => {
        if (isJourney) {
            return codeLists.awardFileCategories.list.filter(i => i.value === AWARD_FILE_CATEGORY_TYPES.adventureJourney.id)
        }

        if (isContainParentalConsent) {
            return codeLists.awardFileCategories.list.filter(i => i.value != AWARD_FILE_CATEGORY_TYPES.parentalConsent.id)
        }

        return codeLists.awardFileCategories.list
    }

    isActivity = () => {
        return (get(this.props.data, 'category.value') === AWARD_FILE_CATEGORY_TYPES.activity.id) ? true : false
    }

    showActivitySection = value => {
        if (value === AWARD_FILE_CATEGORY_TYPES.activity.id) {
            this.setState({ showActivitySection: true })
        } else {
            this.setState({
                showActivitySection: false
            })
        }

        this.setState({ category: value })
    }



    render() {
        const { codeLists, isJourney, isContainParentalConsent, awardFileActivitySection } = this.props

        return (
            <div>
                <Input label="Title" intlKey="label.title" name="title" />
                <Textarea
                    label="Description"
                    intlKey="label.description"
                    name="description"
                />
                <Select
                    label="File category"
                    intlKey="label.file_category"
                    name="category.value"
                    options={this.getFileCategoryList(codeLists, isJourney, isContainParentalConsent)}
                    onSelectChange={obj => this.showActivitySection(obj.value)}
                    clearable={!isJourney}
                    value={isJourney ? AWARD_FILE_CATEGORY_TYPES.adventureJourney.id : this.state.category}
                    disabled={isJourney}
                />

                { this.state.showActivitySection &&
                    <Select
                        className={this.state.showActivitySection ? styles.activitySection : styles.activitySectionDisabled}
                        label="Activity Section"
                        intlKey="label.activity_section"
                        name="section.value"
                        options={awardFileActivitySection}
                    />}
            </div>
        )
    }
}

export default AwardFileInfo
